module.exports = __webpack_public_path__ + "img/BITplan.1995ac8c.png";